/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseFeatureBlockFragment} from '@amblique/contentful/app/contentful/fragments/feature-block/base-feature-block.fragment';
import {BlogFragment} from '@amblique/contentful/app/contentful/fragments/blog/blog.fragment';

export const FullFeatureBlockFragment = gql`
  ${BaseFeatureBlockFragment}
  ${BlogFragment}

  fragment FullFeatureBlockFragment on FeatureBlock {
    ...BaseFeatureBlockFragment

    chooseContentsCollection {
      items {
        __typename
        ... on Blog {
          ...BlogFragment
        }
      }
    }
    chooseContentsCursorCollection {
      items {
        __typename
        ... on Blog {
          ...BlogFragment
        }
      }
    }
  }
`;
